import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVibeCoding: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVibeCoding"><Path d="M10.85 10H10.15L9.275 12.275L7 13.15V13.85L9.275 14.725L10.15 17H10.85L11.725 14.725L14 13.85V13.15L11.725 12.275L10.85 10Z" fill="currentColor"/><Path d="M13.75 6H13.25L12.625 7.625L11 8.25V8.75L12.625 9.375L13.25 11H13.75L14.375 9.375L16 8.75V8.25L14.375 7.625L13.75 6Z" fill="currentColor"/><Path d="M6.5 6.5L2 12L6.5 17.5" stroke="currentColor" strokeLinecap="square"/><Path d="M17.5 6.5L22 12L17.5 17.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconVibeCoding;
